import { QuoteElement } from "./quote-element.js";
import { css, html } from "lit";
import { property } from "lit/decorators.js";
import { SelectedState } from "./selected-state.js";
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const _MultiOfferQuoteElement = class _MultiOfferQuoteElement extends QuoteElement {
  constructor() {
    super(...arguments);
    this.multiMode = false;
  }
  toggleOfferSelection() {
    if (this.selectedState === SelectedState.ACCEPTED) {
      this.reset();
    } else {
      this.accept();
    }
  }
  render() {
    if (this.shouldOverrideQuote && this.quoteOverride) {
      console.log(this.quoteContext);
    }
    return this.shouldOverrideQuote && this.quoteOverride ? this._renderStandardDisplay() : this.quoteController.render({
      complete: () => this.multiMode ? this._renderMultiDisplay() : this._renderStandardDisplay(),
      error: (e) => {
        if (!this.multiMode) {
          return this._renderStandardErrorDisplay(e);
        }
        this.style.setProperty("display", "none");
        return html``;
      }
    });
  }
  /**
   * @ignore
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _renderStandardErrorDisplay(e) {
    return html``;
  }
};
_MultiOfferQuoteElement.styles = [
  QuoteElement.styles,
  css`
      :host {
        width: 100%;
      }

      offer-checkbox-button {
        display: block;
        width: 100%;
        border-radius: var(--default-vi-action-border-radius);
        border: 1px solid var(--default-vi-border-color);
      }

      .multi-offer-item {
        display: flex;
        flex: 1;
        column-gap: 15px;
        width: 100%;
        line-height: 1.25rem;
      }
      .multi-offer-item div:first-child {
        flex: 1;
      }
    `
];
let MultiOfferQuoteElement = _MultiOfferQuoteElement;
__decorateClass([
  property({ attribute: "coverage-context-description" })
], MultiOfferQuoteElement.prototype, "coverageContextDescription");
__decorateClass([
  property({ type: Boolean, attribute: "multi-mode" })
], MultiOfferQuoteElement.prototype, "multiMode");
export {
  MultiOfferQuoteElement
};
